'use client';

// Components
import Navbar from "@src/components/organism/shared/navbar";
import NavbarMobile from "@src/components/organism/shared/navbar-mobile";
import ListListing from "@src/components/organism/list-listing";
import Footer from "@src/components/organism/shared/footer";
import GoldenProperty from '@src/components/organism/shared/golder-property';

// Hooks
import { ListListingProvider } from "@src/context/list-listing-ctx";

const ListListingTemplate = ({ ...props }) => {
  return (
    <ListListingProvider {...props}>
      <>
        <Navbar />
        <div className="hidden dd2-xl:block">
          <NavbarMobile />
        </div>
        <ListListing />
        <GoldenProperty />
        <Footer />
      </>
    </ListListingProvider>
  )
}

export default ListListingTemplate
